module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp"
  }), _vm._v(" "), _c('p', {
    staticClass: "EP"
  }, [_vm._v("Disdaining kings, we give ourselves our laws to the sound of cannons and of bugle calls. And now, on the sinister behalf of black kings, each Judas is a friend of every Cain.")]), _vm._v(" "), _c('p', {
    staticClass: "EPC"
  }, [_c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("—Rubén Darío, “To Columbus”")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0